(function () {
  function initHuichengHome(root) {
    if (!root || root.dataset.huichengReady === 'true') return;
    root.dataset.huichengReady = 'true';

    var revealItems = root.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, currentObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });

    revealItems.forEach(function (item) { observer.observe(item); });
  }

  function boot() {
    document.querySelectorAll('[data-huicheng-home]').forEach(initHuichengHome);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
